import { format } from 'date-fns';

const defaultNumberFormat = new Intl.NumberFormat('en-EN');

export const formatNumber = (number: number): string => defaultNumberFormat.format(number);

export const formatNumberWithSpace = (number: number): string => number.toLocaleString('en-US').replace(/,/g, ' ');

export const convertISOToDate = (isoDate: string): Date => new Date(Date.parse(isoDate));

export const formatDate = (date: Date): string => format(date, 'dd.MM.yyyy HH:mm');

export const formatDateFromISO = (isoDate: string): string => formatDate(convertISOToDate(isoDate));

export const truncateString = (inputString: string): string => {
  const cleanedString = inputString.replace(/[^a-zA-Z0-9]/g, '');

  if (cleanedString.length < 8) {
    return cleanedString;
  }
  const firstPart = cleanedString.substring(0, 4);
  const secondPart = cleanedString.substring(cleanedString.length - 4);

  return `${firstPart}*${secondPart}`;
};

export const titleCase = (string: string): string => string[0].toUpperCase() + string.slice(1).toLowerCase();

export const truncateLabel = (iban: string, length: number = 8, indicator: string = '*'): string => {
  try {
    if (iban.length < length) {
      console.warn(`truncateLabel: The string must have at least ${length} characters`);
      return iban;
    }
    const fullStr = length === iban.length;
    const delimeter = fullStr ? '' : indicator;
    const sliceIdx = Math.floor(length / 2);
    return `${iban.slice(0, sliceIdx)}${delimeter}${iban.slice(-sliceIdx)}`;
  } catch (error) {
    console.error(`truncateLabel error: `, error);
    return '';
  }
};
